import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const initialReadOnly = false;

export const BlueprintContext = createContext(initialReadOnly);

export function BlueprintContextProvider({
  children,
}) {
  const [isReadOnly, setReadOnly] = useState(initialReadOnly);

  const changeToEdit = () => setReadOnly(false);
  const changeToReadOnly = () => setReadOnly(true);

  return (
    <BlueprintContext.Provider
      value={{
        isReadOnly,
        changeToEdit,
        changeToReadOnly,
      }}
    >
      {children}
    </BlueprintContext.Provider>
  );
}

BlueprintContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default BlueprintContextProvider;

export function useBlueprintContext() {
  const context = useContext(BlueprintContext);

  if (!context) throw new Error('useBlueprintContext must be called from a BlueprintContext.Provider');

  return context;
}
